const DOCUMENT_STEP_ID = 'document'
const EMAIL_STEP_ID = 'email'
const TWO_FACTOR_AUTHENTICATION_STEP_ID = 'two_factor_authentication'

const PORTAL_NAMES = {
  privacy_by_design: 'Privacy by Design',
  ai_inventory: 'Inventário de IA',
}

const DEFAULT_PORTAL_NAME = PORTAL_NAMES.privacy_by_design

const STEPS = (companyName) => [
  {
    id: DOCUMENT_STEP_ID,
    text: `Bem-vindo ao Portal de Privacy by Design${
      companyName ? ` da ${companyName}` : ''
    }. Informe o CNPJ ou CPF da empresa para prosseguir.`,
  },
  {
    id: EMAIL_STEP_ID,
    text: 'Identificamos a empresa. Informe o seu e-mail para continuar.',
  },
  {
    id: TWO_FACTOR_AUTHENTICATION_STEP_ID,
    text: 'Quase lá! Digite o código de verificação enviado para o seu e-mail.',
  },
]

export default {
  DEFAULT_PORTAL_NAME,
  DOCUMENT_STEP_ID,
  EMAIL_STEP_ID,
  PORTAL_NAMES,
  STEPS,
  TWO_FACTOR_AUTHENTICATION_STEP_ID,
}
